import { Grid, Text, Stack, Divider, NumberFormatter } from '@mantine/core';
import { Document, Charge } from '@types';

function Charges({ document }: { document: Document }) {
  return (
    <Stack mt={40} gap="0">
      <Grid>
        <Grid.Col span={2} py={0}>
          <Text fw={800} fz={9}>
            Com/Cargo
          </Text>
        </Grid.Col>
        <Grid.Col span={5} py={0}>
          <Text fw={800} fz={9}>
            Glosa
          </Text>
        </Grid.Col>
        <Grid.Col span={2.5} py={0}>
          <Text fw={800} fz={9}>
            Valor Neto
          </Text>
        </Grid.Col>
        <Grid.Col span={2.5} py={0}>
          <Text fw={800} fz={9} ps={10}>
            Valor Exento
          </Text>
        </Grid.Col>
      </Grid>
      <Divider color="black" my={10} />
      <Grid>
        {document?.charges?.map((charge: Charge, index: number) => (
          <>
            <Grid.Col span={2} py={1}>
              <Text fz={9}>{index + 1}</Text>
            </Grid.Col>
            <Grid.Col span={5} py={1}>
              <Text fz={9}>{charge.description}</Text>
            </Grid.Col>
            <Grid.Col span={2.5} py={1}>
              <Text fz={9}>
                <NumberFormatter
                  thousandSeparator="."
                  decimalSeparator=","
                  value={charge.net_amount}
                />
              </Text>
            </Grid.Col>
            <Grid.Col span={2.5} py={1}>
              <Text fz={9}>
                <NumberFormatter
                  thousandSeparator="."
                  decimalSeparator=","
                  value={charge.exempt_amount}
                />
              </Text>
            </Grid.Col>
          </>
        ))}
      </Grid>
    </Stack>
  );
}

export default Charges;
